import React from 'react'
import {
    IconButton,
    Menu,
    MenuHandler,
    MenuList,
    MenuItem,
    Spinner,

} from "@material-tailwind/react";

import { BlobProvider, } from '@react-pdf/renderer';
import AIcon from './AIcon';
import PDFLetter from "../../screens/export_duty_letters/PDFLetter"
import { useShared } from '../../hooks/useShared';



export default function AMenu({ v }) {
    const { auth, com, consts, http, Num2persian } = useShared();
    const setOpenData = (flag) => {
        console.log("object");
        // setGeneratePDF(pre => !pre)
        v.handleMenu(v.row, flag)
    }


    return (
        <Menu
            animate={{
                mount: { y: 0 },
                unmount: { y: 25 },
            }}
        >
            <MenuHandler>
                <IconButton disabled={auth.hasRole([3])} variant="text" className={`h-5 $`}>
                    <AIcon name="ellipsis-horizontal-outline" className="text-main-color text-lg" />
                </IconButton>
            </MenuHandler>

            <MenuList className="min-w-[100px] bg-main-color p-1">


                {
                    v?.menuData?.map((mi, i, { length }) => {
                        // mi.hide = (v.row?.items?.length>0&&mi.name==="Renew" &&!v.row?.items[0]?.expiry&&v.row?.items[0]?.status!==3 );
                        return (
                            <div key={i}>
                                {(auth.hasRole(mi?.roles)) && <React.Fragment>
                                    {(i > 0 && (i < length)) && <hr className={`  my-1 text-main-color`} />}
                                    {(i > 0 && (i < length)) && <hr className={`  my-1 text-cyan-900`} />}

                                    {mi.flag !== 'Generate PDF' && <MenuItem className={`flex  items-center p-1 text-white ${mi.name === 'Delete' && 'hover:text-red-500'}`}
                                        onClick={(e) => setOpenData(mi.flag.toLowerCase())
                                        }>
                                        <AIcon name={mi.icon} className="mr-2" />
                                        {mi.name}
                                    </MenuItem>}

                                    {mi.flag === 'Generate PDF' && <MenuItem className={`flex  items-center p-1 text-white`}
                                        onClick={(e) => setOpenData(mi.flag.toLowerCase())}>
                                        <AIcon name={`logo-foursquare`} className="mr-2" />  PDF ايجاد
                                        {/*  <BlobProvider document={<PDFLetter v={{ model: v.row, com, http }} />}
                                            fileName={'Letter.pdf'}>
                                            {({ blob, url, loading, error }) => {
                                                return (<> {loading ? <div className='flex '> <Spinner className="h-4 w-4 mr-1" /> PDF ...</div> : !loading && url ? <a href={url} target="_blank" rel="noreferrer"> PDF ايجاد   </a> : null} </>)
                                               
                                            }}
                                        </BlobProvider> */}

                                    </MenuItem>}

                                </React.Fragment>
                                }
                            </div>
                        )
                    })
                }
            </MenuList>
        </Menu>
    )
}
